export const content = {
  label: "Address",
  helperText: "",
  placeholder: "Type your address...",
  manualEntry: "Enter address manually...",
  loading: "Looking for your address...",
};
